import { onMount, createSignal, Show } from "solid-js";
import { GoogleMaps } from "../../googlemaps/googlemaps";
import { Spinner } from "solid-bootstrap";

export const GoogleMapsStage = (props) => {
    const [isLoaded, setIsLoaded] = createSignal(false);
    const [isError, setIsError] = createSignal(null);
    var map = null;
    function initMapIfReady() {
        if (map) {
            return true;
        }

        const mapElem = document.getElementById('device-location-googlemaps');
        const wrapperElement = document.getElementById('device-location-googlemaps-container');
        if (mapElem && wrapperElement && google.maps) {
            map = new GoogleMaps(
                props.device, 
                mapElem, 
                wrapperElement, 
                setIsLoaded, 
                setIsError);
            map.initialise(google.maps);
            // console.log("created map");
            return true;
        }
        return false;
    }
    function pollUntilMapReady() {
        var interval = setInterval(() => {
            // console.log("polling for map readiness");
            var mapReady = initMapIfReady();
            if (mapReady) {
                // console.log("clear map poll")
                clearInterval(interval);
            }
        }, 50);
    }
    onMount(() => {
        pollUntilMapReady();
    });
    return <div class="device-location-wapper d-flex flex-column gap-5">
        <h1>Choose your location with Google Maps <i class="fa-brands fa-google"></i> </h1>
        <div id="device-location-googlemaps-container">
            <div id="device-location-googlemaps" />
        </div>
        
        <Show when={!isLoaded()}>
            <Spinner animation="border" />
        </Show>
        <Show when={isError()}>
            <p>Error</p>
        </Show>
        <div>Google Maps™ mapping service is a trademark of Google LLC.</div>
    </div>;
}